export default "__VITE_ASSET__25f1a5e2__"